import { hr } from "../../../../date-fns/locale/hr.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    hr
  }
};